import NaCodeMaintenanceApiURLs from '../../../../apiUrls/NaCodeMaintenanceApiUrls'
import { CodeMaintenanceType } from 'src/constants/nacodemaintenance'
import { components } from 'cng-web-lib'
import PropTypes from 'prop-types'
import React from 'react'
import { getDescriptionByUserLanguage } from 'src/common/TranslationCommon'

const {
  form: {
    field: {
      CngLookupAutocompleteField
    },
  },
} = components

/**
 *
 * @visibleName Code maintenance autocomplete
 */
function NaAceHwyBorderCrossingAutocompleteField(props) {

  const {
    lookupProps = {},
    ...lookupAutocompleteProps
  } = props
  const { filters = [], ...otherLookupProps } = lookupProps

  return (
    <CngLookupAutocompleteField
      {...lookupAutocompleteProps}
      lookupProps={{
        url: NaCodeMaintenanceApiURLs.GET,
        customData: { codeMType: CodeMaintenanceType.DOC_PORT },
        label: (record) => {
          return getDescriptionByUserLanguage(record)
        },
        value: 'code',
        shouldEnableSessionCache: true,
        filters: [
          {
            field: 'active',
            operator: 'equal',
            value: true
          },
          {
            field: 'set_indicator',
            operator: 'equal',
            value: 'BRDR_CROSS'
          },
          {
            field: 'schd_k',
            operator: 'equal',
            value: props.portCode
          },
          ...filters
        ],
        ...otherLookupProps
      }}
    />
  )
}

NaAceHwyBorderCrossingAutocompleteField.propTypes = {
  /** @ignore */
  lookupProps: PropTypes.object
}

export default NaAceHwyBorderCrossingAutocompleteField
